export default {"src":"/_next/static/media/48-icon.9f4f663d.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};